export default __webpack_public_path__ + "static/media/afp-habitat.778e589a.svg";